<div class="active-user px-2 {{className}}">

  <div class="avatar  w-12" (click)="onOpenChat()">
    <app-image-wrapper [avatar]="avatar" [src]="room?.imageId?.s3Url" [pClass]="'h-12 w-12'" [class]="'h-12 w-12 flex-none rounded-full bg-gray-50'"></app-image-wrapper>
    <div class="dot" *ngIf="isActive"></div>
      <div class="count">
          <span class="messages-count" *ngIf="room.notSeenMessagesCount && room.notSeenMessagesCount > 0">{{room.notSeenMessagesCount}}</span>
      </div>
  </div>

  <div class="content" (click)="onOpenChat()">
    <div class="name line-clamp-1">{{name}}</div>
    <div class="publisherName" *ngIf="answeredName">{{answeredName}}</div>
    <div class="messages-info">
      <div class="text">
        <p>{{text | translate}}</p>
      </div>
    </div>
  </div>

  <div class="table_center" *ngIf="showOptions">
    <div class="drop-down {{openInviteDropDawnOptions?'drop-down--active':''}}">
      <div class="drop-down__menu-box">
        <ul class="drop-down__menu">
          <li data-name="profile" class="drop-down__item" (click)="openPopup()">
            {{'delete_room' | translate}}
          </li>
          <li *ngIf="!room.forTable && !room.forId && room.type === 'group'" data-name="profile" class="drop-down__item" (click)="onEditRoom()">
            {{'edit_room' | translate}}
          </li>
        </ul>
      </div>
      <div class="drop-down__button" (click)="toggleInviteDropDawnOptions()">
        <i  class="fa fa-ellipsis-v icon-options"></i>
      </div>


    </div>
  </div>
</div>
